import { Mail, MessageCircle, Instagram } from 'lucide-react';

import {
  SUPPORT_EMAIL,
  SUPPORT_INSTAGRAM_HANDLE,
  SUPPORT_INSTAGRAM_URL,
  getSupportEmailHref,
  getSupportWhatsAppHref,
} from '../lib/contact';
import styles from './ContactLinks.module.css';

interface Props {
  variant?: 'inline' | 'stacked';
  emailSubject?: string;
  whatsappMessage?: string;
  className?: string;
}

export default function ContactLinks({
  variant = 'inline',
  emailSubject,
  whatsappMessage,
  className,
}: Props) {
  const containerClass = [
    styles.container,
    variant === 'inline' ? styles.inline : styles.stacked,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const iconSize = variant === 'inline' ? 14 : 16;

  return (
    <ul className={containerClass} aria-label="Canais de contato">
      <li>
        <a
          href={getSupportEmailHref(emailSubject)}
          className={styles.link}
          aria-label={`Enviar email para ${SUPPORT_EMAIL}`}
        >
          <Mail size={iconSize} aria-hidden="true" />
          <span>Email</span>
        </a>
      </li>
      <li>
        <a
          href={getSupportWhatsAppHref(whatsappMessage)}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
          aria-label="Falar com o suporte no WhatsApp"
        >
          <MessageCircle size={iconSize} aria-hidden="true" />
          <span>WhatsApp</span>
        </a>
      </li>
      <li>
        <a
          href={SUPPORT_INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
          aria-label={`Instagram @${SUPPORT_INSTAGRAM_HANDLE}`}
        >
          <Instagram size={iconSize} aria-hidden="true" />
          <span>Instagram</span>
        </a>
      </li>
    </ul>
  );
}
